// Angular
import { Injectable } from '@angular/core';
// External
import { FirebaseApp } from 'angularfire2';
import { AngularFireDatabase } from 'angularfire2/database';

@Injectable()

export class ApiService {

    constructor(private firebaseApp: FirebaseApp, private fireDatabase: AngularFireDatabase) {
    }

    object(path: string): Promise<any> {
        return new Promise((resolve, reject) => {
            const objectSubscription = this.fireDatabase.object(path).subscribe(result => {
                if(objectSubscription){
                objectSubscription.unsubscribe();

                }
                resolve(result);
            }, error => {
                reject(error);
            });
        });
    }

    list(path: string, options?: any): Promise<any> {
        return new Promise((resolve, reject) => {
            const listSubscription = this.fireDatabase.list(path, options).subscribe(result => {
                listSubscription.unsubscribe();
                resolve(result);
            }, error => {
                reject(error);
            });
        });
    }

    push(path: string, value: any) {
        return this.fireDatabase.database.ref(path).push(value);
    }

    set(path: string, value: any) {
        return this.fireDatabase.database.ref(path).set(value);
    }

    update(path: string, value: any) {
        return this.fireDatabase.object(path).update(value);
    }

    upload(path: string, filename: string, file: File, metadata?: any) {
        return this.firebaseApp.storage().ref(path).child(filename).put(file, metadata);
    }

    remove(path: string) {
        return this.fireDatabase.object(path).remove();
    }

    getKey(path: string) : string
    {
        return this.fireDatabase.database.ref().child(path).push().key;
    }

    bulkUpdate(updates: object)
    {
        return this.fireDatabase.database.ref().update(updates);
    }
}



// WEBPACK FOOTER //
// D:/Rohit's Project/Golfhubber/golfhubber_club_portal/src/app/services/api/api.service.ts